import { render } from "./view-vehicles.vue?vue&type=template&id=8381f7d8"
import script from "./view-vehicles.vue?vue&type=script&lang=js"
export * from "./view-vehicles.vue?vue&type=script&lang=js"

import "./view-vehicles.vue?vue&type=style&index=0&id=8381f7d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__